/* list paging shared by the Needs attention issue table and the Additional payments list. */

// An empty page past the end, left by an action that shrank the list (a resolve, a remove), steps back
// to the last page that has rows. null = stay: also when a lagging total points back at this very page.
export const last_page_offset = ({ offset, row_count, total_count, page_size }) => {
  if (row_count !== 0 || offset <= 0 || total_count <= 0) return null;
  const back = Math.floor((total_count - 1) / page_size) * page_size;
  return back < offset ? back : null;
};
